import type { AuthRole } from '@/api/models';
import { PATH } from './PATH';

/**
 * The home screen for a signed-in user, by role. A `BranchAdmin` can't sell, so
 * lands on the management shell; everyone else (a `Seller`) gets the POS. This
 * is the single source of truth shared by the post-PIN navigation and the route
 * guards, so they can never disagree about where a role belongs.
 */
export const getRoleHomePath = (role: AuthRole | null | undefined): string =>
    role === 'BranchAdmin' ? PATH.MANAGE : PATH.SELLER;
